module.exports = __webpack_public_path__ + "img/banner2.1460ceb1.png";